import React, { useContext, memo, useMemo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import VerticalStaffCard from '../../components/card/VerticalStaffCard';
import HorizontalStaffCard from '../../components/card/HorizontalStaffCard';
import Config from '../../config.json';
import VerticalEntryCard from '../../components/card/VerticalEntryCard';
import HorizontalEntryCard from '../../components/card/HorizontalEntryCard';
import { ListContext } from '../../contexts/ListContext';

const MemoizedVerticalStaffCard = memo(VerticalStaffCard);
const MemoizedHorizontalStaffCard = memo(HorizontalStaffCard);
const MemoizedVerticalEntryCard = memo(VerticalEntryCard);
const MemoizedHorizontalEntryCard = memo(HorizontalEntryCard);

function ListingGrid() {
  const { displayOption, filteredEntries, isEntriesFiltered } = useContext(ListContext);
  
  const renderedEntries = useMemo(() => {
    return filteredEntries?.map((entry, index) => { 
      if (displayOption === 'list') {
        return (
          <Col sm={12} md={12} lg={12} xl={12} key={index}>
            {entry.CategoryID == Config.STAFF_CATEGORY_ID || entry.CategoryID == Config.DIRECTOR_CATEGORY_ID ? (
              <MemoizedHorizontalStaffCard staffMember={entry} />
            ) : (
              <MemoizedHorizontalEntryCard entry={entry} />
            )}
          </Col>
        );
      }
      return (
        <Col sm={12} md={6} lg={4} xl={4} key={index}>
          {entry.CategoryID == Config.STAFF_CATEGORY_ID || entry.CategoryID == Config.DIRECTOR_CATEGORY_ID? (
            <MemoizedVerticalStaffCard staffMember={entry} />
          ) : (
            <MemoizedVerticalEntryCard entry={entry} />
          )}
        </Col>
      );
    });
  }, [filteredEntries, displayOption]);

  return (
    <Container>
      <Row>{isEntriesFiltered ? renderedEntries : <></>}</Row>
    </Container>
  );
}

export default ListingGrid;